/*
 * Blog page  
 */
(function () {
  'use strict';

  var SECTION_SELECTOR = '.blog-posts';
  var swiperInstances = []; 
  function initFilterAndSort(root) {
    var grid = root.querySelector('#main_blog');
    if (!grid) return;

    var cards = Array.prototype.slice.call(grid.querySelectorAll('.js-blog-card'));
    var originalOrder = cards.slice();

    var currentFilter = 'all';

    function applyFilter(filter) {
      currentFilter = filter;
      var visible = 0;

      cards.forEach(function (card) {
        var tags = (card.getAttribute('data-article-tags') || '').split(',');
        var match = filter === 'all' || tags.indexOf(filter) !== -1;
        card.classList.toggle('d-none', !match);
        if (match) visible += 1;
      });

      toggleEmptyState(visible === 0);
    }

    function toggleEmptyState(show) {
      var empty = root.querySelector('.js-blog-empty');
      if (show && !empty) {
        empty = document.createElement('p');
        empty.className = 'js-blog-empty h4 w-100 text-center py-5';
        empty.textContent = grid.getAttribute('data-empty-text') || 'No matching posts.';
        grid.appendChild(empty);
      } else if (!show && empty) {
        empty.remove();
      }
    } 
    root.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-filter]');
      if (!btn || !root.contains(btn)) return;

      root.querySelectorAll('[data-filter]').forEach(function (el) {
        el.classList.remove('active');
      });
      btn.classList.add('active');

      applyFilter(btn.getAttribute('data-filter'));
    });

    function sortCards(mode) {
      var sorted;
      switch (mode) {
        case 'newest_first':
          sorted = cards.slice().sort(function (a, b) {
            return getDate(b) - getDate(a);
          });
          break;
        case 'oldest_first':
          sorted = cards.slice().sort(function (a, b) {
            return getDate(a) - getDate(b);
          });
          break;
        case 'alphabetical_asc':
          sorted = cards.slice().sort(function (a, b) {
            return getTitle(a).localeCompare(getTitle(b));
          });
          break;
        case 'alphabetical_desc':
          sorted = cards.slice().sort(function (a, b) {
            return getTitle(b).localeCompare(getTitle(a));
          });
          break;
        default: // 'featured'
          sorted = originalOrder;
      }
      sorted.forEach(function (card) {
        grid.appendChild(card);
      });
    }

    function getDate(card) {
      return parseInt(card.getAttribute('data-article-date'), 10) || 0;
    }
    function getTitle(card) {
      return card.getAttribute('data-article-title') || '';
    }

    var sortWrap = root.querySelector('.blog-sort');
    if (sortWrap && !sortWrap.dataset.bound) {
      sortWrap.dataset.bound = 'true';
      sortWrap.addEventListener('click', function (event) {
        var btn = event.target.closest('[data-blog-sort]');
        if (!btn) return;
        sortWrap.querySelectorAll('[data-blog-sort]').forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
          if (b === btn) {
            b.setAttribute('aria-current', 'true');
          } else {
            b.removeAttribute('aria-current');
          }
        });
        var toggle = sortWrap.querySelector('.blog-sort__toggle');
        if (toggle) toggle.textContent = btn.textContent.trim();
        sortCards(btn.getAttribute('data-sort-value'));
      });
    }
  }

  
  function initCarousel(root, tries) {
    var el = root.querySelector('.mySwiper');
    if (!el) return; 
    if (typeof Swiper === 'undefined') {
      tries = tries || 0;
      if (tries < 100) {
        window.setTimeout(function () {
          initCarousel(root, tries + 1);
        }, 50);
      }
      return;
    }

    var host = root.querySelector('[data-blog-magazine-production]') || el;
    var autoplaySeconds = parseFloat(host.getAttribute('data-autoplay')) || 0;
    var loopOn = host.getAttribute('data-loop') === 'true';
    var slideCount = el.querySelectorAll('.swiper-slide').length;

    var config = {
      slidesPerView: 1,
      spaceBetween: 0,
      roundLengths: true,
      watchOverflow: true,
      watchSlidesProgress: true,
      observer: true,
      observeParents: true,
      loop: loopOn && slideCount > 1,
      navigation: {
        nextEl: root.querySelector('.swiper-button-next'),
        prevEl: root.querySelector('.swiper-button-prev')
      },
      pagination: {
        el: root.querySelector('.swiper-pagination'),
        clickable: true,
         renderBullet: function (index, className) {
          var pagination = root.querySelector('.swiper-pagination');

          if (!pagination || !pagination.classList.contains('bold')) {
            return '<span class="' + className + '"></span>';
          }

          return (
            '<span class="' + className + ' custom-bullet">' +
            '<svg class="progress-ring" viewBox="0 0 34 34" aria-hidden="true">' +
            '<circle class="progress-ring-bg" cx="17" cy="17" r="16"></circle>' +
            '<circle class="progress-ring-fill" cx="17" cy="17" r="16"></circle>' +
            '</svg>' +
            '<span class="bullet-dot"></span>' +
            '</span>'
          );
        }
      }
    };
    var paginationEl = root.querySelector('.swiper-pagination');

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      autoplaySeconds = 0;
    }
    if (paginationEl && paginationEl.classList.contains('bold') && autoplaySeconds > 0) {
      paginationEl.style.setProperty('--ring-duration', autoplaySeconds + 's');
    }
    if (autoplaySeconds > 0) {
      config.autoplay = { delay: autoplaySeconds * 1000, disableOnInteraction: false, pauseOnMouseEnter: true };
    }

    var progressFill = root.querySelector('[data-blog-progress-fill]');
    var setFromIndex = null;

    if (progressFill) {
      var setProgress = function (ratio) {
        var clamped = Math.max(0, Math.min(1, ratio));
        progressFill.style.transform = 'scaleX(' + clamped + ')';
      };

      setFromIndex = function (swiper) {
        if (slideCount < 2) return setProgress(1);
        setProgress((swiper.realIndex + 1) / slideCount);
      };
    }

    var applyFocus = function (swiper) {
      if (window.ThemeSlideFocus) {
        window.ThemeSlideFocus.apply(swiper, { focusableSlides: false });
      }
    };
    config.on = {
      init: function (swiper) {
        if (setFromIndex) setFromIndex(swiper);
      },
      slideChange: function (swiper) {
        if (setFromIndex) setFromIndex(swiper);
      },
      afterInit: applyFocus,
      resize: applyFocus,
      update: applyFocus,
      slideChangeTransitionEnd: function (swiper) {
        applyFocus(swiper);
        if (window.ThemeSlideFocus) {
          window.ThemeSlideFocus.followActive(swiper, el);
        }
      }
    };

    var instance = new Swiper(el, config);
    swiperInstances.push(instance);
    if (window.SectionCarousel && window.SectionCarousel.bindAutoplayFocusPause) {
      window.SectionCarousel.bindAutoplayFocusPause(el, instance);
    }
  }
 
  function initSection(root) {
    if (!root || root.dataset.blogEnhanced === 'true') return;
    root.dataset.blogEnhanced = 'true';
    initFilterAndSort(root);
    initCarousel(root);
  }

  function initAll() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector
      ? event.target.querySelector(SECTION_SELECTOR)
      : null;
    if (event.target.matches && event.target.matches(SECTION_SELECTOR)) {
      root = event.target;
    }
    if (root) {
      delete root.dataset.blogEnhanced;
      initSection(root);
    }
  });

  document.addEventListener('shopify:section:unload', function () {
    swiperInstances.forEach(function (s) {
      if (s && typeof s.destroy === 'function') s.destroy(true, true);
    });
    swiperInstances = [];
  });
})();
